// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DidYouKnowBar_wrapper__OyWl9","content":"DidYouKnowBar_content__Rmr9V","body":"DidYouKnowBar_body___6lLp","title":"DidYouKnowBar_title__2l3HO"};